import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { getAllHeroSectionsPublic, getHeroSectionByIdPublic, getHeroSectionsByTypePublic } from '../../api/herosection/PublicHeroSEction';


// Hook to fetch all hero sections
export const useHeroSectionsPublic = () => {
  const {
    data,
    isLoading,
    error,
    refetch
  } = useQuery('heroSectionsPublic', getAllHeroSectionsPublic, {
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to fetch hero sections');
    },
    staleTime: 300000, // 5 minutes
    cacheTime: 3600000, // 1 hour
  });

  return {
    heroSections: data?.data || [],
    isLoading,
    error,
    refetchHeroSections: refetch
  };
};

// Hook to fetch hero sections by type
export const useHeroSectionsByTypePublic = (type) => {
  const {
    data,
    isLoading,
    error,
    refetch
  } = useQuery(['heroSectionsPublic', type], () => getHeroSectionsByTypePublic(type), {
    onError: (error) => {
      toast.error(error?.response?.data?.message || `Failed to fetch ${type} hero sections`);
    },
    staleTime: 300000, // 5 minutes
    cacheTime: 3600000, // 1 hour
    enabled: !!type, // Only run query if type is provided
  });

  return {
    heroSections: data?.data || [],
    isLoading,
    error,
    refetchHeroSections: refetch
  };
};

// Hook to fetch a single hero section by ID
export const useHeroSectionByIdPublic = (id) => {
  const {
    data,
    isLoading,
    error,
    refetch
  } = useQuery(['heroSectionPublic', id], () => getHeroSectionByIdPublic(id), {
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to fetch hero section');
    },
    staleTime: 300000, // 5 minutes
    cacheTime: 3600000, // 1 hour
    enabled: !!id, // Only run query if id is provided
  });

  return {
    heroSection: data?.data || null,
    isLoading,
    error,
    refetchHeroSection: refetch
  };
};

